// import appLocaleData from 'react-intl/locale-data/zh';
import jpMessages from './lang/ja-JP.json';
import antdJp from 'antd/lib/locale-provider/ja_JP'; //antd语言包
// console.log(1111,appLocaleData)
let appLocale = {
  messages: {
    ...jpMessages,
  },
  antd: antdJp,
  locale: 'ja-JP',
};

export default appLocale;
